/* eslint-disable no-nested-ternary */
import { ChangeEvent, KeyboardEventHandler, useState } from 'react'
import { EyeOfLine } from '../../assets/icons/eye-off-line'
import { EyeIcon } from '../../assets/icons/eyes'
import { ButtonEye, FormLogin, InputLogin, LabelLogin } from './Input.style'

type InputProps = {
  value: string
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  changeIsPassword?: boolean
  labelText?: string
  onKeyDown?: KeyboardEventHandler<HTMLInputElement> | undefined
  placeholder?: string
  marginBotton?: boolean
}

export function Input({
  value,
  onChange,
  changeIsPassword,
  labelText,
  onKeyDown,
  placeholder,
  marginBotton,
}: InputProps) {
  const [isShowingPassword, setIsShowingPassword] = useState(true)

  const isPassword = () => setIsShowingPassword(!isShowingPassword)
  const [isFocused, setIsFocused] = useState(false)

  const handleFocus = () => {
    setIsFocused(true)
  }

  const handleBlur = () => {
    setIsFocused(false)
  }
  return (
    <FormLogin className={isFocused ? 'focused' : ''}>
      <InputLogin
        marginBotton={marginBotton}
        onFocus={handleFocus}
        onBlur={handleBlur}
        value={value}
        onChange={onChange}
        onKeyUp={onKeyDown}
        type={
          changeIsPassword ? (isShowingPassword ? 'password' : 'text') : 'text'
        }
        placeholder={placeholder}
      />

      <LabelLogin>{labelText}</LabelLogin>

      {changeIsPassword && (
        <ButtonEye type="button" onClick={isPassword}>
          {isShowingPassword ? <EyeOfLine /> : <EyeIcon />}
        </ButtonEye>
      )}
    </FormLogin>
  )
}
